const GUIDE_SETTINGS_DIALOG_SHORTCUTS_ATTR = 'data-guide-settings-dialog-shortcuts-disabled'

export function setGuideSettingsDialogShortcutsDisabled(disabled: boolean): void {
  if (typeof document === 'undefined') return

  if (disabled) {
    document.body.setAttribute(GUIDE_SETTINGS_DIALOG_SHORTCUTS_ATTR, 'true')
    return
  }

  document.body.removeAttribute(GUIDE_SETTINGS_DIALOG_SHORTCUTS_ATTR)
}

export function areGuideSettingsDialogShortcutsDisabled(): boolean {
  if (typeof document === 'undefined') return false

  return document.body.getAttribute(GUIDE_SETTINGS_DIALOG_SHORTCUTS_ATTR) === 'true'
}
